import Cookies from 'js-cookie'
import React from 'react'

// This is the name of the cookie set in the product-web app which stores the current session status of a user.
const SESSION_STATUS_KEY = 'isLoggedIn'

// This is the name of the cookie set in the commercial-helios app which stores the historical session status of a user.
const PREVIOUS_SESSION_STATUS_KEY = 'hasLoggedInPreviously'

export const useUser = () => {
    const hasCurrentSessionCookie = Cookies.get(SESSION_STATUS_KEY) === 'true'
    const hasPreviousSessionCookie = Cookies.get(PREVIOUS_SESSION_STATUS_KEY) === 'true'

    React.useEffect(() => {
        if (hasCurrentSessionCookie) {
            Cookies.set(PREVIOUS_SESSION_STATUS_KEY, 'true', {expires: 365})
        }
    }, [hasCurrentSessionCookie])

    return {
        isLoggedIn: hasCurrentSessionCookie,
        hasLoggedInPreviously: hasPreviousSessionCookie || hasCurrentSessionCookie,
    }
}
